var map = {
	"./2021-07-09-14-13-04-995.jpg": 1408,
	"./2021-08-03_14-30-43_124.png": 3465,
	"./2021-08-03_14-31-02_128.png": 5027,
	"./2021-08-03_14-34-02_699.png": 6211,
	"./2021-08-03_14-35-16_530.png": 5383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3238;